import orgContainer from '@Components/AppContainer';
import InnerComponent from '@Components/Admin/Integration/TallyIntegration/TallySetup';

const TallySetup = () => ((orgContainer(InnerComponent)));
export default TallySetup;
